module.exports = __webpack_public_path__ + "static/media/1.6ff2f65f.JPG";